import request from '@/common/request'

export default {
    /**
     * Excel 批量导入功能
     *
     * @param file 文件
     * @return 失败结果集
     */
    uploadBatchExcel: data => {
        return request({
            url: '/v1/publishManage/uploadExcel',
            method: 'post',
            data
        })
    },
    downIssue: (orgCode,data) => {
        return request({
            url: `/v1/publishManage/issue/${orgCode}`,
            method: 'patch',
            data
        })
    },
    /**
     *  create 增
     *  delete 删
     *  update 改
     *  query  查
     */
    createPublishManage: (dynaSeg, data, params) => {
        return request({
            url: '/v1/publishManage',
            method: 'post',
            data,
            params
        })
    },
    deletePublishManage: dynaSeg => {
        return request({
            url: `/v1/publishManage/${dynaSeg.id}`,
            method: 'delete',
        })
    },
    updatePublishManage: (dynaSeg, data, params) => {
        return request({
            url: `/v1/publishManage/${dynaSeg.id}`,
            method: 'put',
            data,
            params
        })
    },
    queryPublishManage: params => {
        return request({
            url: '/v1/publishManage',
            method: 'get',
            params
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/publishManage.js